import React, { Component } from 'react'
import {Row,Col,notification} from "antd";

// components
import TodoDetailsModal from './modal/todoDetails'
// model
import TodoDetails from '../../notice/model/todoDetails'
// service
import AppService from '../../app.service'

interface iProps {
    todo: TodoDetails,
    getNoticeList: () => void,
    getNumber: () => void,
    finishTodo: () => {},
    displayWrap?: boolean
}

interface iState {
    modalVisible: boolean,
    readStatus: boolean
}
export default class todoItem extends Component<iProps, iState> {
    private appService: AppService = new AppService()
    state: iState = {
        modalVisible: false,
        readStatus: false
    }
    calculateDay = (data) => {
        if (data === 0) 
            return <span className="todoItem_deadline_today">需当日完成</span>
        else if (data > 0)
            return <span className="todoItem_deadline_delay">已延期{data}天</span>
        else if (data < 0)
            return <span className="todoItem_deadline_due">{data*(-1)}天后到期</span>
        else if (!data)
            return
    }
    checkTodoDetails = async () => {
        let data = await this.appService.markReadTodo([this.props.todo.todoId])
        if (data === 'ok') {
            await this.setState({readStatus: true})
            await this.setState({modalVisible: true})
            this.props.getNoticeList()
        }
    }
    // 删除todo
    deleteMessage = async () => {
        const that = this
        let data = await that.appService.deleteTodo([that.props.todo.todoId])
        if (data === 'ok') {
            await that.setState({modalVisible: false})
            that.props.getNumber()
            notification['success']({
                message: '删除成功',
                duration: 1
            })
        }
    }
    // todo标记为完成
    finishTodo = async () => {
        let data = await this.appService.finishTodo(this.props.todo.todoId)
        const that = this
        if (data === 'ok') {
            notification['success']({
                message: '已修改为完成',
                duration: 1,
                onClose () {
                    that.props.finishTodo()
                }
            })
        }
    }
    componentWillReceiveProps (nextProps) {
        if (this.props.todo != nextProps.todo) {
            this.setState({readStatus: false})
        }
    }
    render() {
        let {todo, displayWrap = true} = this.props
        let {modalVisible, readStatus} = this.state
        return (
            <>
                <div className="todoItem" onClick={this.checkTodoDetails}>
                {displayWrap &&
                    <>
                    <Row className="todoItem_top">
                        <Col span={18} className="todoItem_title"
                            style={{color: !readStatus ? 'rgba(0,0,0,.85)' : 'rgba(0,0,0,.35)'}}>
                            {todo.title}
                        </Col>
                        <Col span={6} className="todoItem_status">
                            {
                                todo && todo.finishedState &&
                                <span className="todoItem_status_done">已完成</span>
                            }
                            {
                                todo && (!todo.finishedState) &&
                                <span className="todoItem_status_notdone">未完成</span>
                            }
                        </Col>
                    </Row>
                    <Row className="todoItem_bottom" style={{color: !readStatus ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.35)'}}>
                        <Col span={18} className="todoItem_deatils">
                            <span className="todoItem_department">{todo.systemName}</span>
                            <span>截止时间：{todo.deadlineDate}</span>
                        </Col>
                        <Col span={6} className="todoItem_deadline">
                            {this.calculateDay(todo.overDayNumber)}
                        </Col>
                    </Row>
                    </>
                    }
                    {
                        !displayWrap &&
                        <div className="todoItem_nowrap">
                            <div className="todoItem_nowrap_title">
                                <span className="todoItem_nowrap_title_text" style={{color: !readStatus ? 'rgba(0,0,0,.85)' : 'rgba(0,0,0,.35)'}}>{todo.title}</span>
                                <span className="todoItem_status">
                                    {
                                        todo && todo.finishedState &&
                                        <span className="todoItem_status_done">已完成</span>
                                    }
                                    {
                                        todo && (!todo.finishedState) &&
                                        <span className="todoItem_status_notdone">未完成</span>
                                    }
                                </span>
                            </div>
                            <div className="todoItem__nowrap_mes"  style={{color: !readStatus ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.35)'}}>
                                <span className="todoItem__nowrap_senduser">{todo.systemName}-{todo.deadlineDate}</span>
                            </div>
                        </div>
                    }
                </div>
                <TodoDetailsModal
                    todo = {todo}
                    visible={modalVisible}
                    onCancel={() => {this.setState({modalVisible: false})}}
                    deleteMessage = {this.deleteMessage}
                    finishTodo = {this.finishTodo}
                ></TodoDetailsModal>
            </>
        )
    }
}
